<template>
  <div :key="isUpdate">
    <div v-if="loading">
      <ResourceLoadStatus :loading="true"></ResourceLoadStatus>
    </div>

    <div
      v-else-if="isMobileScreenSize === false"
      class="uk-flex uk-flex-column uk-flex-center uk-flex-middle grid-background"
      :class="{ 'web-main-panel': status === 'accept' }"
    >
      <div
        class="login-panel uk-padding uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-width-1-2@m uk-width-2-5@l uk-width-2-3@s uk-width-1-3@xl"
      >
        <div
          class="uk-margin uk-text-center uk-text-large uk-text-bolder uk-card uk-card-default uk-width-1-1 land-page-up-container"
        >
          <img
            class="login-icon uk-padding uk-flex"
            style="height: 100%; width: 100%; object-fit: contain"
            src="/icons/Official-OpenVetting-Logo-Light.png"
          />
          <div v-if="status === 'decline' || isDeclineInvitation">
            <h2 class="uk-text-bolder uk-margin-remove-top uk-margin-remove-bottom font-color">
              Regrets...
            </h2>
          </div>
          <div v-else-if="showTooLate">
            <h2 class="font-color" style="font-size: 1.4em">The challenge has been met</h2>
          </div>
          <div v-else>
            <h2 class="uk-text-bold uk-margin-remove-top font-color">Join the debate!</h2>
          </div>
        </div>

        <div
          v-if="showTooLate"
          class="uk-text-center uk-card uk-card-default land-page-bottom-container uk-width-1-1"
        >
          <p class="font-color">
            Thank you for your interest in the OpenVetting debate: "{{ document.title }}."
            Unfortunately that invitation has already been accepted.
          </p>
          <p class="font-color">We hope to include your thoughts in the future!</p>
          <p class="font-color">
            Click here to <a href="https://openvetting.ai/"><b>learn</b></a> more.
          </p>
          <div class="uk-flex uk-flex-around">
            <button
              class="uk-button uk-button-primary uk-button-large uk-border-rounded uk-text-capitalize uk-margin-bottom"
              @click="viewTheDebate"
            >
              Watch the debate
            </button>
            <button
              class="uk-button uk-button-primary uk-button-large uk-border-rounded uk-text-capitalize uk-margin-bottom"
              @click="goToMydiscussions"
            >
              Start a New Topic
            </button>
          </div>
        </div>

        <div
          v-else
          class="uk-text-center uk-card uk-card-default land-page-bottom-container uk-width-1-1"
        >
          <div v-if="status === 'accept' && !isDeclineInvitation" class="accept-text">
            <div v-if="invitation.permissionLevel === PermissionLevel.TEAM_LEAD">
              <div v-if="requestedPrivacyLevel === 'Optional'">
                <p>{{ invitedBy.firstname }} has deferred to you on confidentiality.</p>
                <div class="privacy-options">
                  <form-group v-for="option in privacyOptions" :key="option.value">
                    <label>
                      <input
                        class="uk-radio"
                        type="radio"
                        v-model="privacySelection"
                        :value="option.value"
                      />
                      <span class="uk-margin-small-left" v-html="option.label"></span>
                    </label>
                  </form-group>
                </div>
              </div>
              <p v-else-if="requestedPrivacyLevel === 'Private'">
                {{ invitedBy.firstname }} has asked this discussion be kept confidential to
                yourselves and respective advisors.
              </p>
              <p v-else>
                In the interest of public learning, discussions on OpenVetting are shareable via
                social media.
              </p>
            </div>
            <div v-else-if="invitations.permissionLevel === PermissionLevel.COHORT">
              <p class="uk-text-large font-color">
                You were invited by {{ invitedBy.firstname }} to help support their discussion.
              </p>
            </div>
            <div v-if="invitations.permissionLevel === PermissionLevel.MEMBER">
              <p v-if="requestedPrivacyLevel === 'Private'">
                {{ invitedBy.firstname }} has asked this discussion be kept confidential.
              </p>
            </div>
            <div class="uk-flex uk-flex-around">
              <LoaderButton
                class="uk-button uk-button-primary uk-button-large uk-margin-top uk-text-bold"
                :loaderStatus="acceptLoadStatus"
                @click="acceptInvitation"
              >
                {{ 'Accept' }}
              </LoaderButton>
              <LoaderButton
                class="uk-button uk-button-primary uk-button-large uk-margin-top uk-text-bold"
                :loaderStatus="declineLoadStatus"
                @click="declineInvitation()"
              >
                {{ 'Decline' }}
              </LoaderButton>
            </div>
          </div>

          <div v-else-if="status === 'decline' || isDeclineInvitation" class="decline-text">
            <p class="uk-text-large font-color">
              We’re sorry this OpenVetting debate was not of interest
            </p>
            <p class="uk-text-large font-color">
              We hope to include your thoughts on another topic in the future.
            </p>
            <p class="uk-text-large font-color">
              Click here to <a href="https://openvetting.ai/"><b>learn</b></a> more.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isMobileScreenSize === true">
      <MobileLandingPage
        :status="status"
        :invitations="invitations"
        @submit="acceptInvitation"
        @doDeclineClick="declineInvitation()"
        :acceptSavingStatus="acceptLoadStatus"
        :declineSavingStatus="declineLoadStatus"
        :requestedPrivacyLevel="requestedPrivacyLevel"
        :isAccept="isAccept"
        :joinDebatePage="joinDebatePage"
        @doReminderClick="doReminderClick"
        :mobileViewRespons="mobileViewRespons"
        :acceptBtnShow="acceptBtnShow"
        :showTooLate="showTooLate"
        :isDecline="isDeclineInvitation"
      />
    </div>
  </div>
</template>
<script>
import LoaderButton from '@/components/display/button/LoaderButton.vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { xhr } from '../../xhr/endpoints';
import { errors } from '../../errors/errors';
import MobileLandingPage from '@/views/public/MobileLandingPage';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import ResourceLoadStatus from '@/components/general/ResourceLoadStatus';

export default {
  name: 'WebAppLandingPage',

  data() {
    return {
      privacySelection: 'Public',
      privacyOptions: [
        {
          label: 'Enable sharing',
          value: 'Public',
        },
        {
          label: 'Prefer confidentiality',
          value: 'Private',
        },
      ],
      invitationType: null,
      invitation: null,
      status: null,
      isAccept: false,
      joinDebatePage: true,
      acceptLoadStatus: '',
      declineLoadStatus: '',
      loading: false,
      showTooLate: false,
      mobileViewRespons: false,
      acceptBtnShow: false,
      isDeclineInvitation: false,
      isUpdate: 0,
      observerData: [],
    };
  },
  async mounted() {
    //
    this.status = this.$route.params.status;
    // start loader while retrieving invitation data
    this.loading = true;

    if (this.$route.params.status === 'accept') {
      this.acceptBtnShow = true;
      try {
        //
        // retrieve invitation data
        const response = await xhr.getInvitation(this.$route.params.invitationID);
        if (response) {
          this.mobileViewRespons = true;
        }
        this.invitation = response.invitation;
        this.invitationType = response.type;
        //
        // setup privacy selection
        if (this.requestedPrivacyLevel !== 'Optional')
          this.privacySelection = this.requestedPrivacyLevel;
        //
        // validate invitees authorization
        // use case-insensitive validation
        const userEmailsLowerCase = this.userData.emails.map(email => email.toLowerCase());
        const inviteeData = this.invitation.invitees.find(invitee =>
          userEmailsLowerCase.includes(invitee.email.toLowerCase())
        );
        if (inviteeData.status === 'Expired') {
          this.showTooLate = true;
          this.acceptBtnShow = false;
        }
        if (!inviteeData || inviteeData.status === 'Awaiting Send') this.notAuthorized = true;
      } catch (e) {
        if (e instanceof errors.UnauthorizedError) {
          this.notAuthorized = true;
        } else if (e instanceof errors.NotFoundError) {
          this.notFound = true;
        }
      } finally {
        //
        // stop loader
        this.loading = false;
      }
    } else if (this.status === 'decline') {
      await xhr.declineTeamInvitation(this.$route.params.invitationID);
    }
    this.loading = false;
  },

  components: {
    LoaderButton,
    MobileLandingPage,
    ResourceLoadStatus,
  },
  computed: {
    PermissionLevel() {
      return PermissionLevel;
    },
    ...mapState(['publicLinkData', 'userData', 'challengeDetails']),
    ...mapGetters(['isMobileScreenSize', 'permissionLevel']),
    requestedPrivacyLevel() {
      let rubyHashString = this.invitation?.privacy;
      let jsonString = '';
      if (rubyHashString) {
        jsonString = rubyHashString.replace(/:(\w+)=>/g, '"$1":').replace(/"/g, '"');
      }
      let jsonObject = '';
      if (jsonString) {
        jsonObject = JSON.parse(jsonString);
      }
      return this.invitation ? jsonObject.selected : '';
    },
    invitations() {
      return this.invitation ? this.invitation : {};
    },
    invitedBy() {
      return this.invitation && this.invitation?.invitedBy ? this.invitation.invitedBy : {};
    },
    organization() {
      return this.invitation && this.invitation?.organization?.name
        ? this.invitation.organization.name
        : '-';
    },
    document() {
      return this.invitation && this.invitation?.document ? this.invitation.document : {};
    },
    publicLinkMessage() {
      return this.publicLinkData?.message
        ? this.publicLinkData?.message?.replace(/\n/g, '<br />')
        : '';
    },
  },
  props: {
    loadingStatus: String,
  },
  methods: {
    ...mapMutations([
      'setIdTokenFromStorage',
      'setAcceptDeclineStatus',
      'setAcceptDecline',
      'setChallengeUrl',
      'setObserverStatus',
    ]),
    handleRegister() {
      this.setAcceptDeclineStatus('');
      this.$router.push('/').catch(() => {
        void 0;
      });
    },
    SignIn() {
      this.$emit('signIn');
    },
    goToMydiscussions() {
      this.$router.push('/discussions');
      this.setChallengeUrl(false);
      this.setAcceptDecline(false);
    },
    async doReminderClick(time) {
      try {
        await xhr.reminderTeamInvitation(this.invitation._id, time, this.idToken);
      } catch (e) {
        console.log(e);
        alert('Could not Reminder Invitation');
      }
    },
    async viewTheDebate() {
      this.setObserverStatus(true);
      this.setChallengeUrl(false);
      this.setAcceptDecline(false);
      if (!Array.isArray(this.observerData)) {
        this.observerData = [];
      }
      this.observerData.push(this.invitation.document._id);
      localStorage.setItem('isObserver', JSON.stringify(this.observerData));
      this.$router.pushRoute.Debate(this.invitation.document._id);
    },
    async acceptInvitation(privacy) {
      try {
        this.acceptLoadStatus = LoadingStatus.LOADING;
        await xhr.acceptTeamInvitation(this.invitation._id, privacy || this.privacySelection);
        this.acceptLoadStatus = LoadingStatus.SUCCESS;
        if (this.isMobileScreenSize) {
          this.joinDebatePage = false;
          this.isAccept = true;
          this.acceptBtnShow = false;
        } else {
          this.setAcceptDecline(false);
          if (this.invitation.permissionLevel === PermissionLevel.COHORT) {
            this.$router.pushRoute.CuratorDebate(this.invitation.document._id);
          } else {
            this.$router.pushRoute.Debate(this.invitation.document._id);
          }
        }
      } catch (e) {
        this.acceptLoadStatus = LoadingStatus.FAILED;
        console.log(e);
        this.showTooLate = true;
      }
    },
    async declineInvitation() {
      try {
        this.declineLoadStatus = LoadingStatus.LOADING;
        this.$router.push(`/invitation/${this.$route.params.invitationID}/decline`);
        await xhr.declineTeamInvitation(this.$route.params.invitationID);
        this.declineLoadStatus = LoadingStatus.SUCCESS;
        this.isUpdate++;
        this.isDeclineInvitation = true;
      } catch (error) {
        this.declineLoadStatus = LoadingStatus.FAILED;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.web-main-panel
  margin: -40px !important
.land-page-up-container
  border-radius: 15px 15px 0 0
  padding: 5% 0
.land-page-bottom-container
  border-radius: 0 0 15px 15px
  padding: 5% 5%
.decline-text
  padding: 12% 25%
.font-color
  color: #254858
.accept-text
  padding: 7% 0
</style>
